var map = {
	"./bg-home.png": 8732,
	"./default_avatar.png": 5822,
	"./default_avatar_female.png": 9491,
	"./default_avatar_male.png": 8012,
	"./default_avatar_neutral - Copia.png": 1455,
	"./default_avatar_neutral.png": 6414,
	"./doctor.png": 4610,
	"./doctors-patients-summary.svg": 7751,
	"./icons/icon-voltar.svg": 8162,
	"./logo-cuidando.jpg": 5788,
	"./logo-lila.png": 3865,
	"./weekly_report_level_pain_0.png": 6034,
	"./weekly_report_level_pain_1.png": 9691,
	"./weekly_report_level_pain_2.png": 4288,
	"./weekly_report_level_pain_3.png": 41,
	"./weekly_report_level_pain_4.png": 1414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;